import * as Actions from 'reducks/tag/actions'
import { initialState } from 'reducks/reduxStore/initialState'

export const TagReducer = (state = initialState.tag, action: any) => {
  switch (action.type) {
    case Actions.FETCH_TAGS:
      return {
        ...state,
        tags: [...action.payload],
      }
    default:
      return state
  }
}
